import { IonContent, IonInput, IonPage, IonText, IonTextarea, IonSpinner } from "@ionic/react";
import moment from "moment";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import Head from "../Header";
import Sidebar from "../Sidebar";
import swal from 'sweetalert';

const Compoffhistory: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [loading, setloading] = useState(false)
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [modalData, setModalData] = useState(null);
    const [leaveType, setLeaveType] = useState("");
    const [statusList, setStatusList] = useState([]);

    /*......................... View & Update  .......................*/

    const [id, setId] = useState("");
    const [Ids, setid] = useState("");
    const [leave, setLeave] = useState("");
    const [status, setStatus] = useState("");
    const [status1, setStatus1] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [empName, setEmpName] = useState("");
    const [reportingPerson, setReportingPerson] = useState("");
    const [empCode, setEmpCode] = useState("");
    const [noOfDays, setNoOfDays] = useState("");
    const [remarks, setRemarks] = useState("");
    const [empid, setEmpid] = useState("")
    const [workdate, setworkdate] = useState("");
    const [reason, setreason] = useState("");
    const [date, setdate] = useState("");
    const [statusid, setStatusid] = useState("");

 //--------------------Manager-Approval Datatable-------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "70px",

        },
        {
            name: "Employee Code",
            selector: (itm: any) => itm.employeeDetails.employeeCode,
            sortable: true,

        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.employeeDetails.name,
            sortable: true,
        },
        {
            name: "Worked On",
            selector: (itm: any) => moment(itm.workedOnDate).format("DD-MM-YYYY"),
            sortable: true,
        },
        {
            name: "Status",
            selector: (itm: any) => itm.compOffStatus.status,
            sortable: true,
        },
        
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm, itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ];

    //--------------------Search Filter--------------------//

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                padding: "0px",
                justifyContent: "center"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //------------------View Api-------------------//

    const openmodal = (itm: any, id: any) => {
        setModalData(itm);
        console.log("Row Data:", itm);
        setEmpid(itm.employeeId)
        setEmpCode(itm.employeeDetails.employeeCode);
        setEmpName(itm.employeeDetails.name);
        setworkdate(itm.workedOnDate);
        setreason(itm.reason)
        setid(itm.id)
        setId(id);
        setModalopen(true);
    }

    const closemodal = () => {
        setModalopen(false);
        setId("");
    }

     //------------------Compoff-View Approve Api-----------------------//

    const Compoffsave = (approvalStatus: boolean, item: any) => {


        var id: any;

        if (item.compOffStatus.status === "Pending" && approvalStatus === true) {
            var id2: any = compOffStatusData.find((item: any) => item.status === "Approved")

            id = id2.id
            console.log(id, "klniio")
        }
        else if (item.compOffStatus.status === "Registered" && approvalStatus === true) {
            var id2: any = compOffStatusData.find((item: any) => item.status === "Open")

            id = id2.id
            console.log(id, "klniio")
        }
        else if ( approvalStatus === false) {
            var id2: any = compOffStatusData.find((item:any) => item.status === "Rejected");
            approvalStatus = true
            id = id2.id;
            console.log(id, "klniio");
        }
        
        console.log(approvalStatus,"uiuii")
        service.Compoffupdate(Ids, empid, workdate, reason,remarks, id, date, approvalStatus)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    swal("", response.data.message, "success")
                        .then(() => {
                            window.location.reload();
                        });
                }
                else {
                    swal("", response.data.message, "error")
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };
 
    //----------------------Status Api------------------------//

    const [compOffStatusData, setComoffStatusData] = useState([]);

    const GetStatus = () => {

        service.GetCompoffstatus()
            .then((response) => {
                console.log(response, "response for compoff status");
                if (response.data.status === 200) {
                    setComoffStatusData(response.data.data)
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //----------------GetAll UseEffect---------------//

    useEffect(() => {
        Compoffapprovetable();
        GetStatus();
    }, []);

 //----------------------Compoff-Approve Api-----------------//

    const Compoffapprovetable = () => {
        service.CompoffApproval(token)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    setData(response.data.data);
                }
            })
            .catch((error) => {
                console.error(error);

            });
    };


    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />Compoff History</h3>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "2%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal dialogClassName="modal-dialog modal-lg" data={modalData} show={modalopen}>
                    <div className="modal-header">
                        <h5 className="modal-title">Compensatory Off</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Employee Id<span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={empCode}  readonly className="form-control datetimepicker" />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Employee Name<span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={empName} readonly className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Worked Holiday<span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={workdate} readonly type='date' className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className=" form-group">
                                    <label style={{ fontWeight: "bold" }}>Reason<span className="text-danger">*</span></label>
                                    <textarea value={reason} readOnly className="form-control" />
                                </div>
                                <div  style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                                <button  onClick={closemodal} type="button" className="btn btn-primary submit-btn">
                        Exit
                    </button>
                                </div>
                                
                                {/* <div className="submit-section">
                                    <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                        <div>
                                            <button onClick={() => Compoffsave(true, modalData)} type="button" className="btn btn-primary submit-btn">
                                                Approve
                                            </button>

                                        </div>
                                        <div>
                                            <button onClick={() => Compoffsave(false, modalData)} type="button" className="btn btn-secondary submit-btn" >
                                                Reject
                                            </button>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default Compoffhistory;
